import { Incident } from './types';

const compareIncidents = (first: Incident, second: Incident): number =>
  (first.iconApp || '').localeCompare(second.iconApp || '');

export const groupIncidents = (incidents: Incident[]): Incident[][] => {
  const sorted = [...incidents].sort(compareIncidents);

  let lastIconApp: string | null;

  const groups: Incident[][] = [];

  sorted.forEach(incident => {
    if (incident.iconApp !== lastIconApp) {
      lastIconApp = incident.iconApp;
      groups.push([]);
    }

    groups[groups.length - 1].push(incident);
  });

  return groups;
};
